import { EventService } from '../../../base/services/EventService'
import { Widget } from '../base'
import { PermutatorService } from '../base/permutator'

class WidgetContainerBreadcrumbServiceProvider {
  protected breadcrumbContainerUUID = ''
  protected breadcrumbs: Widget[] = []
  protected selectWidgetCb

  protected renderBreadcrumbs() {
    EventService.$emit('breadcrumbs-populate', this.breadcrumbContainerUUID, this.breadcrumbs)
  }

  protected hideBreadcrumbs() {
    this.breadcrumbContainerUUID = ''
    this.breadcrumbs = []
    this.renderBreadcrumbs()
  }

  protected onSelectWidget(component) {
    if (!component) {
      if (this.breadcrumbContainerUUID) {
        this.hideBreadcrumbs()
      }

      return
    }

    const breadcrumbs: Widget[] = []
    let $el = component.$el

    while (($el !== null) && ($el.nodeType === 1)) {
      // sometimes el.className is not a string but an object
      // tslint:disable-next-line: strict-type-predicates
      const classes = (typeof $el.className === 'string') ? $el.className.split(' ') : []
      const uuid = $el.getAttribute('data-wbuuid')

      $el = $el.parentNode as HTMLElement

      if ((classes.indexOf('widget') === -1) || !uuid) {
        continue
      }

      const widget = PermutatorService.getByUUID(uuid) as Widget

      if (!widget) {
        continue
      }

      breadcrumbs.unshift(widget)
    }

    if (breadcrumbs && !breadcrumbs[0].rows) {
      breadcrumbs.length = 0
    }

    const targetContainerUUID = breadcrumbs.length ? breadcrumbs[0].wbUUID! : ''

    if (!targetContainerUUID && this.breadcrumbContainerUUID) {
      this.hideBreadcrumbs()
    }

    this.breadcrumbContainerUUID = targetContainerUUID
    this.breadcrumbs = breadcrumbs

    if (this.breadcrumbContainerUUID) {
      this.renderBreadcrumbs()
    }
  }

  init() {
    this.selectWidgetCb = this.onSelectWidget.bind(this)
    EventService.$on('widget-select', this.selectWidgetCb)
  }

  destroy() {
    if (!this.selectWidgetCb) {
      return
    }

    EventService.$off('widget-select', this.selectWidgetCb)
    this.selectWidgetCb = undefined
  }
}

export const WidgetContainerBreadcrumbService = new WidgetContainerBreadcrumbServiceProvider()
